import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiservicesService } from '../../../apiservices.service';
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-log-audit',
  templateUrl: './log-audit.component.html',
  styleUrls: ['./log-audit.component.css']
})
export class LogAuditComponent implements OnInit {
  //UI Status Variable
  SearchStatus : boolean = false;
  LoaderStatus: boolean = false;
  ViewActionStatus: boolean = false;

  //UI Input Variables
  SearchTypeInput: any = "";
  TINInput: any = "";
  ModuleInput: any = "";
  PageInput: any = "";
  ActionInput: any = "";
  IDTypeInput:any = "";
  IDNoInput: any = "";
  StartRegisterDateInput: any = "";
  EndRegisterDateInput: any = "";

  //UI View Variables
  ModuleView: any = "";
  PageView: any = "";
  ActionView: any = "";
  SearchTypeView: any = "";
  IDTypeView: any = "";
  IDNoView: any = "";
  TaxRefNumView: any = "";

  //UI View Detail
  DateDetailView: any = "";
  StaffNameDetailView: any = "";
  StaffIDNoDetailView: any = "";
  ModuleDetailView: any = "";
  PageDetailView: any = "";
  ActionDetailView: any = "";
  TaxRefNumDetailView: any = "";
  TaxPayerNameDetailView: any = "";
  DescriptionDetailView: any = "";

  //UI Dropdown List Variables
  PageViewList: any[] = [];
  ActionViewList: any[] = [];

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //Session Variables
  SessionFirmID: any = "";

  //Datatable Variables
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSource = new MatTableDataSource();
  displayedColumns = ['pcname','tin', 'module', 'page', 'tindakan', 'staffname', 'staffidno', 'action'];
  RecordCount: any = "";

  constructor(private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.top.updateTotal();
    this.AirDatePickerInit();
  }
  AirDatePickerInit() {
    //const now = new Date();
    new AirDatepicker('#startdate', {
      locale: localeEn,
      dateFormat: "yyyy-MM-dd",
      //minDate: now,
      //isMobile: true,
    })
    new AirDatepicker('#enddate', {
      locale: localeEn,
      dateFormat: "yyyy-MM-dd",
      //minDate: now,
      //isMobile: true,
    })
  }
  Hantar(Module: any, Page: any, Action: any,SearchType:any, IDType: any, IDNo: any,TaxRefNum:any) {
    let startdate = document.getElementById('startdate') as HTMLInputElement | null;
    let enddate = document.getElementById('enddate') as HTMLInputElement | null;
    
    this.LoaderStatus = true;
    if (Module === "" && SearchType === "" && startdate?.value == "" && enddate?.value == "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (SearchType === "pc" && TaxRefNum === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (SearchType === "pc" && isNaN(TaxRefNum)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan TIN yang tepat";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (SearchType === "pt" && (IDType === "1" && isNaN(IDNo))) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan MyKad/MyPR/MyKAS yang tepat";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (SearchType === "pt" && ((IDType === "" && IDNo === "") || (IDType !== "" && IDNo === "") || (IDType === "" && IDNo !== ""))) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if ((startdate?.value !== "" && enddate?.value === "") || (startdate?.value === "" && enddate?.value !== "")) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else {
      if ((startdate?.value !== "" || enddate?.value !== "")) {
        let tempStartDate = new Date(startdate?.value || '');
        let tempEndDate = new Date(enddate?.value || '');
        if (!this.isValidDate(tempStartDate) || !this.isValidDate(tempEndDate)) {
          this.AlertType = "fail";
          this.AlertMessage = "Sila masukkan tarikh yang tepat";
          this.AlertStatus = true;
          setTimeout(() => {
            this.AlertStatus = false;
          }, 1001);
          this.SearchStatus = false;
          this.LoaderStatus = false;
        } else {
          this.ModuleView = Module;
          this.PageView = Page;
          this.ActionView = Action;
          this.SearchTypeView = SearchType;
          this.IDTypeView = IDType;
          this.IDNoView = IDNo;
          this.TaxRefNumView = TaxRefNum;
          this.StartRegisterDateInput = startdate?.value;
          this.EndRegisterDateInput = enddate?.value;
          this.GetData(Module, Page, Action, SearchType, startdate?.value, enddate?.value, IDType, IDNo, TaxRefNum, 0, 10);
        }
      } else {
        this.ModuleView = Module;
        this.PageView = Page;
        this.ActionView = Action;
        this.SearchTypeView = SearchType;
        this.IDTypeView = IDType;
        this.IDNoView = IDNo;
        this.TaxRefNumView = TaxRefNum;
        this.StartRegisterDateInput = startdate?.value;
        this.EndRegisterDateInput = enddate?.value;
        this.GetData(Module, Page, Action, SearchType, startdate?.value, enddate?.value, IDType, IDNo, TaxRefNum, 0, 10);
      }
    }
  }
  OnChangeModule(value:any) {
    if (value === "Pembayar Cukai") {
      this.PageViewList = [{
        Name: "Penerimaan Pelantikan Ejen Cukai",
        Value: "Penerimaan Pelantikan Ejen Cukai"
      },
      {
        Name: "e-Borang",
        Value: "e-Borang"
      },
      {
        Name: "Status e-Borang",
        Value: "Status e-Borang"
      }];
    } else if (value === "Integrasi") {
      this.PageViewList = [
      //{
      //  Name: "Profil Firma",
      //  Value: "Profil Firma"
      //},
      //{
      //  Name: "Muat Naik XML (e-BaS / e-Dts)",
      //  Value: "Muat Naik XML (e-BaS / e-Dts)"
      //},
      //{
      //  Name: "Muat Naik XML (e-BaS / e-Dts) Bukan Lantikan",
      //  Value: "Muat Naik XML (e-BaS / e-Dts) Bukan Lantikan"
      //},
      {
          Name: "Cetak Draf",
          Value: "Cetak Draf"
      },
      {
          Name: "Penghantaran e-Borang",
          Value: "Penghantaran e-Borang"
      }];
    } else if (value === "Penyenggaraan") {
      this.PageViewList = [{
        Name: "Daftar / Kemaskini",
        Value: "Daftar / Kemaskini"
      },
      {
        Name: "Agihan Hubungan",
        Value: "Agihan Hubungan"
      },
      {
        Name: "Agih e-Borang (Ejen Cukai)",
        Value: "Agih e-Borang (Ejen Cukai)"
      }];
    }
    this.ActionViewList = [];
    this.ViewActionStatus = false;
  }
  OnChangePage(value: any) {
    this.ViewActionStatus = true;
    if (value === "Penerimaan Pelantikan Ejen Cukai") {
      this.ActionViewList = [{
        Name: "Daftar e-Borang",
        Value: "Daftar e-Borang"
      },
      {
        Name: "Set Semula e-Borang",
        Value: "Set Semula e-Borang"
      },
      {
        Name: "Agih e-Borang",
        Value: "Agih e-Borang"
      },
      {
        Name: "Lulus Lantikan",
        Value: "Lulus Lantikan"
      },
      {
        Name: "Tolak Lantikan",
        Value: "Tolak Lantikan"
      },
      {
        Name: "Batal Lantikan",
        Value: "Batal Lantikan"
      }];
    }
    else if (value === "e-Borang") {
      this.ActionViewList = [{
        Name: "Daftar e-Borang",
        Value: "Daftar e-Borang"
      },
      {
        Name: "Set Semula e-Borang",
        Value: "Set Semula e-Borang"
      },
      {
        Name: "Agih e-Borang",
        Value: "Agih e-Borang"
      }];
    }
    else if (value === "Status e-Borang") {
      this.ActionViewList = [{
        Name: "Set Semula e-Borang",
        Value: "Set Semula e-Borang"
      },
      {
        Name: "Agih e-Borang",
        Value: "Agih e-Borang"
      }];
    }
    else if (value === "Penghantaran e-Borang") {
      this.ActionViewList = [{
        Name: "Hantar e-Borang",
        Value: "Hantar e-Borang"
      }];
    }
    else if (value === "Daftar / Kemaskini") {
      this.ActionViewList = [
        {
          Name: "Daftar Pengguna",
          Value: "Daftar Pengguna"
        },
        {
          Name: "Kemaskini Pengguna",
          Value: "Kemaskini Pengguna"
        },
        {
          Name: "Kemaskini Ejen Cukai",
          Value: "Kemaskini Ejen Cukai"
        },
        {
          Name: "Hapus Pengguna",
          Value: "Hapus Pengguna"
        }
      ];
    }
    else if (value === "Agihan Hubungan") {
      this.ActionViewList = [
        {
          Name: "Agih Hubungan Staf",
          Value: "Agih Hubungan Staf"
        },
        {
          Name: "Agih Hubungan Ejen",
          Value: "Agih Hubungan Ejen"
        }
      ];
    }
    else if (value === "Agih e-Borang (Ejen Cukai)") {
      this.ActionViewList = [
        {
          Name: "Agih e-Borang",
          Value: "Agih e-Borang"
        }
      ];
    }
    else {
      this.ActionViewList = [];
      this.ViewActionStatus = false;
    }
    
  }
  OnChangeSearchType() {
    this.IDTypeInput = "";
    this.IDNoInput = "";
    this.TINInput = "";
  }
  async GetData(Module: any, Page: any, Action: any,SearchType:any, StartDate:any, EndDate:any, IDType:any, IDNo:any,TaxRefNum:any,PageNum:any, PageSize:any) {
    let Params = {
      "FirmID": this.SessionFirmID,
      "Module": Module === "" ? null : Module,
      "Page": Page === "" ? null : Page,
      "Action": Action === "" ? null : Action,
      "StartDate": StartDate === "" ? null : StartDate,
      "EndDate": EndDate === "" ? null : EndDate,
      "IDNo": IDNo === "" ? null : IDNo,
      "TIN": TaxRefNum === "" ? null : TaxRefNum,
      "PageNum": PageNum,
      "PageSize": PageSize
    };
    const result = await this.apiServices.GetLogAudit(Params);
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.RecordCount = 0;
      this.dataSource = new MatTableDataSource();
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else {
      result.records.forEach((currentValue: any, index: any) => {
        result.records[index].taxPayerName = result.records[index].taxPayerName === null || result.records[index].taxPayerName === "" || result.records[index].taxPayerName === undefined ? "N/A" : result.records[index].taxPayerName;
        result.records[index].EmployerName = result.records[index].EmployerName === null || result.records[index].EmployerName === "" || result.records[index].EmployerName === undefined ? "N/A" : result.records[index].EmployerName;
        result.records[index].dateTime = result.records[index].dateTime === null || result.records[index].dateTime === undefined || result.records[index].dateTime === "" ? "N/A" : formatDate(result.records[index].dateTime, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.records[index].taxPayerItRefNo = result.records[index].taxPayerItRefNo === null || result.records[index].taxPayerItRefNo === "" || result.records[index].taxPayerItRefNo === undefined ? "N/A" : result.records[index].taxPayerItRefNo;
        result.records[index].huraian = result.records[index].huraian === null || result.records[index].huraian === "" || result.records[index].huraian === undefined ? "N/A" : result.records[index].huraian;
      });
      this.SearchStatus = true;
      this.RecordCount = result.total;
      this.dataSource = new MatTableDataSource(result.records);
      this.LoaderStatus = false;
    }
  }
  paginatorEvent(e: PageEvent) {
    this.LoaderStatus = true;
    this.GetData(this.ModuleView, this.PageView, this.ActionView, this.SearchTypeView, this.StartRegisterDateInput, this.EndRegisterDateInput, this.IDTypeView, this.IDNoView, this.TaxRefNumView, e.pageIndex, e.pageSize);
  }
  ViewDetail(value: any) {
    this.DateDetailView = value.dateTime;
    this.StaffNameDetailView = value.staffName;
    this.StaffIDNoDetailView = value.staffIdno;
    this.ModuleDetailView = value.modul;
    this.PageDetailView = value.halaman;
    this.ActionDetailView = value.tindakan;
    this.TaxRefNumDetailView = value.taxPayerItRefNo;
    this.TaxPayerNameDetailView = value.EmployerName !== "N/A" ? value.EmployerName : value.taxPayerName;
    this.DescriptionDetailView = value.huraian === null || value.huraian === "" ? "N/A" : value.huraian;
  }
  Semula() {
    this.SearchStatus = false;
    this.LoaderStatus = false;

    this.ModuleInput = "";
    this.PageInput = "";
    this.ActionInput = "";
    this.IDTypeInput = "";
    this.IDNoInput = "";
    this.StartRegisterDateInput = "";
    this.EndRegisterDateInput = "";
    this.SearchTypeInput = "";
    this.TINInput = "";
    

    this.ModuleView = "";
    this.PageView = "";
    this.ActionView = "";
    this.IDTypeView = "";
    this.IDNoView = "";
    this.SearchTypeView = "";
    this.TaxRefNumView = "";
    this.TaxPayerNameDetailView = "";

    this.DateDetailView = "";
    this.StaffNameDetailView = "";
    this.StaffIDNoDetailView = "";
    this.ModuleDetailView = "";
    this.PageDetailView = "";
    this.ActionDetailView = "";
    this.TaxRefNumDetailView = "";
    this.DescriptionDetailView = "";

    this.PageViewList = [];
    this.ActionViewList = [];

    this.dataSource = new MatTableDataSource();
    this.RecordCount = "";

    (<HTMLInputElement>document.getElementById('startdate')).value = "";
    (<HTMLInputElement>document.getElementById('enddate')).value = "";
  }
  isValidDate(date: any) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
  }
}
